import { reactive } from 'vue';
import type { Job } from '@qjob/shared';

export interface JobFormModalState {
  isOpen: boolean;
  rowIndex?: number;
  sheetName?: string;
  draftId?: string;
  prefillJob?: Record<string, any>;
}

export const jobFormModal = reactive<JobFormModalState>({
  isOpen: false,
  rowIndex: undefined,
  sheetName: undefined,
  draftId: undefined,
  prefillJob: undefined,
});

export function openJobFormNew(draftId?: string, prefillJob?: Record<string, any>) {
  jobFormModal.rowIndex = undefined;
  jobFormModal.sheetName = undefined;
  jobFormModal.draftId = draftId || undefined;
  jobFormModal.prefillJob = prefillJob;
  jobFormModal.isOpen = true;
}

export function openJobFormEdit(job: Pick<Job, '_rowIndex' | '_sheetName'>) {
  if (!job._rowIndex) return;
  jobFormModal.rowIndex = job._rowIndex;
  jobFormModal.sheetName = job._sheetName;
  jobFormModal.draftId = undefined;
  jobFormModal.prefillJob = undefined;
  jobFormModal.isOpen = true;
}

export function closeJobForm() {
  jobFormModal.isOpen = false;
  jobFormModal.rowIndex = undefined;
  jobFormModal.sheetName = undefined;
  jobFormModal.draftId = undefined;
  jobFormModal.prefillJob = undefined;
}
